import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {BonusBunniesGameAssets} from "../BonusBunniesGameAssets";
import {Align, Direction, GuiLayout} from "@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout";

/**
 * Created by Jerker Nord on 2020-03-25.
 */

export class BonusBunniesIntroPage extends SlideShowPage{

    constructor(texture:PIXI.Texture, text:string) {
        super(undefined, undefined, 0x432215);

        const textContainer:PIXI.Container = new PIXI.Container();
        const image:PIXI.Sprite = new PIXI.Sprite(texture);

        const style = new PIXI.TextStyle({
            fill : 0xedc19e,
            fontFamily : "Open Sans",
            wordWrap : true,
            padding : 20,
            wordWrapWidth : 420,
            fontSize : 30,
            breakWords : true
        });
        const styledText = new PIXI.Text(SlotGame.api.translations.translate(text), style);
        textContainer.addChild(styledText);
        textContainer.addChild(image);
        GuiLayout.align([image, styledText], 24, Align.CENTER, Direction.HORIZONTAL);
        textContainer.pivot.set(textContainer.width * 0.5, 0);
        textContainer.position.set(0, -190);
        this.addChild(textContainer);
    }
}